import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { LocaleProvider } from '@betina/ui'
import App from './App.jsx'
import './index.css'

const root = createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LocaleProvider defaultLocale={navigator.language.startsWith('fr') ? 'fr' : 'en'}>
        <App />
      </LocaleProvider>
    </BrowserRouter>
  </React.StrictMode>
)
